export default "__VITE_ASSET__yOiWtFL26e7mPTEYtqos8A__"